import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'docRg'
})
export class DocRgPipe implements PipeTransform {

  transform(value: string): string {
    let num = "";
    if (value) {
      num = value;
      num = num.replace(/\D/g, "");

      switch (num.length) {
        case 4:
          num = num.replace(/(\d+)(\d{3})/, " $1.$2");
          break;
        case 5:
          num = num.replace(/(\d+)(\d{3})/, " $1.$2");
          break;
        case 6:
          num = num.replace(/(\d+)(\d{3})/, " $1.$2");
          break;
        case 7:
          num = num.replace(/(\d+)(\d{3})(\d{3})/, " $1.$2.$3");
          break;
        case 8:
          num = num.replace(/(\d+)(\d{3})(\d{3})/, " $1.$2.$3");
          break;
        case 9:
          num = num.replace(/(\d+)(\d{3})(\d{3})/, " $1.$2.$3");
          break;
        case 10:
          num = num.replace(/(\d+)(\d{3})(\d{3})(\d{3})/, " $1.$2.$3.$4");
          break;
        case 11:
          num = num.replace(/(\d+)(\d{3})(\d{3})(\d{3})/, " $1.$2.$3.$4");
          break;
          case 12:
            num = num.replace(/(\d+)(\d{3})(\d{3})(\d{3})/, " $1.$2.$3.$4");
            break;
        default:
          num = num;
          break;
      }
    }
    return num;
  }

}
